import styled from 'styled-components';

export const Container = styled.div`
  background: ${props => props.theme.colors.surface};
  box-shadow: ${props => props.theme.shadows.md};
  border-radius: ${props => props.theme.radii.md};
  border: none;
  padding: ${props => props.theme.spacing.xxl}
    ${props => props.theme.spacing.xxxl};

  > button {
    background: ${props => props.theme.colors.surface};
    border-radius: ${props => props.theme.radii.md};
    border: none;
    position: absolute;
    right: -7px;
    top: -7px;

    img {
      width: 25px;
      height: 25px;
    }
  }

  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: ${props => props.theme.colors.surface};
    > img {
      width: 60px;
      height: 60px;
      margin-bottom: ${props => props.theme.spacing.xl};
    }

    > h3 {
      font-style: normal;
      font-weight: ${props => props.theme.typography.weights.semibold};
      font-size: ${props => props.theme.typography.sizes.xxl};
      line-height: ${props => props.theme.typography.lineHeights.xl};
      text-align: center;
      color: ${props => props.theme.colors.success};
    }

    > p {
      font-style: normal;
      font-weight: ${props => props.theme.typography.weights.regular};
      font-size: ${props => props.theme.typography.sizes.sm};
      line-height: ${props => props.theme.typography.lineHeights.sm};
      text-align: center;
      color: ${props => props.theme.colors.textSecondary};
    }
  }
`;
